class MaModel extends HTMLElement {
  constructor() {
    super();
    this.openButton = this.querySelector('.ma-modal__open-btn');
    this.contentContainer = this.querySelector('.ma-model__content');
    this.modalContainer = document.querySelector('.ma-modal__container');
    this.closeButton = this.modalContainer.querySelector('.ma-modal__close-button');
    this.backdrop = this.modalContainer.querySelector('.ma-modal__backdrop');
    this.closeModalButton = this.modalContainer.querySelector('.ma-modal__close-btn');
    this.modalText = this.modalContainer.querySelector('.ma-modal__text');
  }
  connectedCallback() {
    this.openButton.addEventListener('click', this.openModal.bind(this));
    this.closeButton.addEventListener('click', this.closeModal.bind(this));
    this.closeModalButton.addEventListener('click', this.closeModal.bind(this));
    this.backdrop.addEventListener('click', this.closeModal.bind(this));
  }
  disconnectedCallback() {
    this.openButton.removeEventListener('click', this.openModal);
    this.closeButton.removeEventListener('click', this.closeModal);
    this.closeModalButton.removeEventListener('click', this.closeModal);
    this.backdrop.removeEventListener('click', this.closeModal);
  }
  openModal() {
    this.modalContainer.style.display = 'flex';
    this.modalContainer.style.opacity = '0';
    this.modalContainer.querySelector('.ma-modal__wrapper').style.transform = 'translateY(10%)';
    this.modalContainer.querySelector('.ma-modal__wrapper').style.opacity = '0';
    setTimeout(() => {
      this.modalContainer.style.transition = 'opacity 0.4s ease-in-out';
      this.modalContainer.querySelector('.ma-modal__wrapper').style.transition = 'transform 0.4s ease-in-out, opacity 0.4s ease-in-out';
      this.modalContainer.style.opacity = '1';
      this.modalContainer.querySelector('.ma-modal__wrapper').style.transform = 'translateY(0%)';
      this.modalContainer.querySelector('.ma-modal__wrapper').style.opacity = '1';
      this.modalText.innerHTML = this.contentContainer.innerHTML;
    }, 10);
  }
  closeModal() {
    this.modalContainer.querySelector('.ma-modal__wrapper').style.transform = 'translateY(10%)';
    this.modalContainer.querySelector('.ma-modal__wrapper').style.opacity = '0';
    setTimeout(() => {
      this.modalContainer.style.display = 'none';
      this.modalContainer.style.opacity = '0';
    }, 300);
  }
}
customElements.define('ma-model', MaModel);
